import Vue from 'vue'
import Router from 'vue-router'
import SearchIndex from '@/components/searchIndex/searchIndex'
import GoodsList from '@/components/goodsList/goodsList'
import GoodsDetail from '@/components/goodsDetail/goodsDetail'
import ShopBag from '@/components/shopBag/shopBag'
import OrderList from '@/components/orderList/orderList'
import UserCenter from '@/components/userCenter/userCenter'
import SubmitOrder from '@/components/submitOrder/submitOrder'
import AddrList from '@/components/addrList/addrList'
import EditAddr from '@/components/editAddr/editAddr'
import InvoiceAddrList from '@/components/invoiceAddrList/invoiceAddrList'
import InvoiceEditAddr from '@/components/invoiceEditAddr/invoiceEditAddr'
import InvoiceList from '@/components/invoiceList/invoiceList'
import EditInvoice from '@/components/editInvoice/editInvoice'
import PayInfo from '@/components/payInfo/payInfo'
import OrderDetail from '@/components/orderDetail/orderDetail'
import PackageDetail from '@/components/packageDetail/packageDetail'
import Login from '@/components/login/login'
import Register from '@/components/login/register'
import EditBasicInfo from '@/components/login/editBasicInfo'
import ServerItem from '@/components/login/serverItem'
import PackageList from '@/components/packageList/packageList'
import Prepay from '@/components/prepay/prepay'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'SearchIndex',
      component: SearchIndex,
      meta:{
      	pageBelong:'GoodsSearch'
      }
    },
    {
      path: '/SearchIndex',
      name: 'SearchIndex',
      component: SearchIndex,
      meta:{
      	pageBelong:'GoodsSearch'
      }
    },
    {
      path: '/GoodsList/:keyword',
      name: 'GoodsList',
      component: GoodsList,
      meta:{
      	pageBelong:'GoodsSearch'
      }
    },
    {
      path: '/GoodsList',
      name: 'GoodsList',
      component: GoodsList,
      meta:{
      	pageBelong:'GoodsSearch'
      }
    },
    {
      path: '/GoodsDetail/:goodsId',
      name: 'GoodsDetail',
      component: GoodsDetail,
      meta:{
      	pageBelong:'GoodsSearch'
      }
    },
    {
      path: '/ShopBag',
      name: 'ShopBag',
      component: ShopBag,
      meta:{
      	pageBelong:'ShopBag'
      }
    },
    {
      path: '/SubmitOrder',
      name: 'SubmitOrder',
      component: SubmitOrder,
      meta:{
      	pageBelong:'ShopBag'
      }
    },
    {
      path: '/OrderList',
      name: 'OrderList',
      component: OrderList,
      meta:{
      	pageBelong:'OrderList'
      }
    },
    {
      path: '/UserCenter',
      name: 'UserCenter',
      component: UserCenter,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/AddrList',
      name: 'AddrList',
      component: AddrList,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/AddrList/:isSelect',
      name: 'AddrList',
      component: AddrList,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/EditAddr',
      name: 'EditAddr',
      component: EditAddr,
      meta:{
      	pageBelong:'EditAddr'
      }
    },
    {
      path: '/InvoiceAddrList',
      name: 'InvoiceAddrList',
      component: InvoiceAddrList,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/InvoiceAddrList/:isSelect',
      name: 'InvoiceAddrList',
      component: InvoiceAddrList,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/InvoiceEditAddr',
      name: 'InvoiceEditAddr',
      component: InvoiceEditAddr,
      meta:{
      	pageBelong:'InvoiceEditAddr'
      }
    },
    {
      path: '/InvoiceList',
      name: 'InvoiceList',
      component: InvoiceList,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/InvoiceList/:isSelect',
      name: 'InvoiceList',
      component: InvoiceList,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/EditInvoice',
      name: 'EditInvoice',
      component: EditInvoice,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/PayInfo',
      name: 'PayInfo',
      component: PayInfo,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/OrderDetail/:orderId',
      name: 'OrderDetail',
      component: OrderDetail,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta:{
      	pageBelong:''
      }
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register,
      meta:{
      	pageBelong:''
      }
    },
    {
      path: '/EditBasicInfo',
      name: 'EditBasicInfo',
      component: EditBasicInfo,
      meta:{
      	pageBelong:'UserCenter'
      }
    },
    {
      path: '/ServerItem',
      name: 'ServerItem',
      component: ServerItem,
      meta:{
      	pageBelong:''
      }
    },
    {
      path: '/PackageList',
      name: 'PackageList',
      component: PackageList,
      meta:{
        pageBelong:'UserCenter'
      }
    },
    {
      path: '/PackageDetail/:packageId',
      name: 'PackageDetail',
      component: PackageDetail,
      meta:{
        pageBelong:'UserCenter'
      }
    },
    {
      path: '/Prepay',
      name: 'Prepay',
      component: Prepay,
      meta:{
        pageBelong:'UserCenter'
      }
    },
    {
      path: '/*',
      name: 'SearchIndex',
      component: SearchIndex,
      meta:{
      	pageBelong:'SearchIndex'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js